<template>
  <div>
    <CRow class="mt-4">
      <CCol>
        <a
          v-if="campaignStatus != 'Scheduled'"
          @click="clickToCancel()"
          class="text-decoration-none d-flex-inline align-items-center font-weight-normal text-gray-600"
          style="cursor: pointer"
        >
          <CIcon name="arrow" :height="15" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
          {{ $t('campaign.campaignSummary.link.backToEdit') }}
        </a>
        <a
          v-else
          @click="gotoCampaingList()"
          class="text-decoration-none text-uppercase d-flex-inline align-items-center font-weight-normal text-gray-600"
          style="cursor: pointer"
        >
          <CIcon name="arrow" :height="15" class="icon__rotateLeft mr-2" viewBox="0 0 32 32" />
          {{ $t('campaign.campaignSummary.link.backToList') }}
        </a>
      </CCol>
    </CRow>
    <CRow class="pt-5">
      <CCol sm="2" v-if="loading">
        <LoadingSpinner size="sm" />
      </CCol>
      <CCol sm="12" class="d-flex flex-column">
        <div class="d-flex justify-content-between">
          <h2 class="titlePage font-weight-normal text-capitalize mb-4">
            {{ pageTitle }}
          </h2>
        </div>
        <div class="d-flex justify-content-between">
          <h5 class="titlePage font-weight-normal text-capitalize">
            <!-- {{ campaignName }} -->
            {{ $t('campaign.campaignResume.subTitle') }}
          </h5>
        </div>
      </CCol>
    </CRow>
  </div>
</template>

<script>
import LoadingSpinner from './LoadingSpinner.vue'
export default {
  components: {
    LoadingSpinner,
  },
  props: {
    campaignName: {
      type: String,
      default: '',
    },
    pageTitle: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    campaignStatus: {
      type: String,
    },
  },
  methods: {
    clickToCancel() {
      this.$emit('cancel-campaign')
    },
    gotoCampaingList() {
      this.$router.push({ name: 'campaignList' })
    },
  },
}
</script>

<style></style>
